// extracted by mini-css-extract-plugin
module.exports = {"blockCopyright":"copyright_blockCopyright__3zZMt","copyrightText":"copyright_copyrightText__2eiV_"};